const proposalRecruitmentTypes = Object.freeze({
  Compania: 1,
  EntidadEducativa: 2,
  Individuo: 3,
  DBA: 4,
});

export default proposalRecruitmentTypes;
